import React, { useState } from 'react';
import { Button, Col, Form, Input, Radio, Row, Spin } from 'antd';
import { IoAdd } from 'react-icons/io5';
import { LoadingOutlined } from '@ant-design/icons';
import UploadImages from '_components/LeadPageCarValuationForm/UploadImages';
import checkIcon from '_images/lead-page-check-icon.svg';
import classNames from 'classnames';
import { submitData } from '_components/LeadPageCommonForms/api';

type Props = {
  token: string,
  onDone: (token: string) => void,
  currentValues: Object,
};

const CarValuationOptionalInfoForm = ({
  token,
  onDone,
  currentValues = {},
}: Props) => {
  const [busy, setBusy] = useState(false);
  const [showUploadPhotosForm, setShowUploadPhotosForm] = useState(false);
  const [doneUploadPhotos, setDoneUploadPhotos] = useState(false);

  const onFinish = (values) => {
    setBusy(true);
    submitData(values, 3, token, 'car-valuation')
      .then(function (res) {
        if (res.data.result === 'Success') {
          onDone(res.data.token, values);
        }
      })
      .finally(() => setBusy(false));
  };

  const showUploadForm = () => {
    setShowUploadPhotosForm(true);
  };

  return (
    <>
      <div className={classNames(showUploadPhotosForm ? 'block' : 'hidden')}>
        <UploadImages
          token={token}
          onDone={() => {
            setShowUploadPhotosForm(false);
            setDoneUploadPhotos(true);
          }}
          onCancel={() => setShowUploadPhotosForm(false)}
          currentValues={currentValues}
        />
      </div>
      <Form
        className={classNames(
          'lead-page-form opacity-95 lg:opacity-100 transition-opacity',
          showUploadPhotosForm ? 'hidden' : 'block'
        )}
        onFinish={onFinish}
      >
        <Spin
          indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
          spinning={busy}
        >
          <h3 className="text-center mb-0 font-semibold">
            {currentValues.vehicle_no}
          </h3>
          <h4 className="text-center mt-0">Optional Details</h4>
          <div className="text-center mb-6">
            Obtain a more accurate quote by providing <br />
            the following optional information.
          </div>
          <Form.Item name="purchase_from">
            <Radio.Group>
              <Radio value={'Authorized Agent'}>Authorized Agent</Radio>
              <Radio value={'Parallel Importer'}>Parallel Importer</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item name="asking_price">
            <Input type="text" placeholder="Asking price" />
          </Form.Item>
          <Form.Item name="condition">
            <Input.TextArea placeholder="Condition" />
          </Form.Item>
          <Form.Item name="accessories">
            <Input.TextArea placeholder="Accessories/Features" />
          </Form.Item>

          <Row>
            <Col xs={{ span: 20 }} md={{ span: 16 }}>
              <label className="font-bold mr-2">Accident free</label>
              <Form.Item name="accident_free">
                <Radio.Group>
                  <Radio value={'1'}>Yes</Radio>
                  <Radio value={'0'}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col xs={{ span: 4 }} md={{ span: 8 }}>
              <div className="flex justify-end mt-1">
                {!doneUploadPhotos ? (
                  <Button
                    type="primary"
                    htmlType="button"
                    size={'small'}
                    onClick={showUploadForm}
                  >
                    <div className="flex justify-start gap-1">
                      <IoAdd size={22} />
                      <span className="hidden md:block">Upload Photo</span>
                    </div>
                  </Button>
                ) : (
                  <img width="22" height="21" alt="Uploaded!" src={checkIcon} />
                )}
              </div>
            </Col>
          </Row>
          <Button
            type="primary"
            htmlType="submit"
            className="get-quote-button"
            size="large"
          >
            Submit
          </Button>
        </Spin>
      </Form>
    </>
  );
};

export default CarValuationOptionalInfoForm;
